<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7495 32.508C13.7495 35.8743 11.0206 38.6032 7.65425 38.6032C4.28796 38.6032 1.55902 35.8743 1.55902 32.508C1.55902 29.1417 4.28796 26.4128 7.65425 26.4128C11.0206 26.4128 13.7495 29.1417 13.7495 32.508ZM38.1305 32.508C38.1305 35.8743 35.4015 38.6032 32.0352 38.6032C28.6689 38.6032 25.94 35.8743 25.94 32.508C25.94 29.1417 28.6689 26.4128 32.0352 26.4128C35.4015 26.4128 38.1305 29.1417 38.1305 32.508ZM56.416 38.6032C59.7824 38.6032 62.5113 35.8743 62.5113 32.508C62.5113 29.1417 59.7824 26.4128 56.416 26.4128C53.0499 26.4128 50.3211 29.1417 50.3211 32.508C50.3211 35.8743 53.0499 38.6032 56.416 38.6032Z"
  />
</template>
